var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Searchclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "22fm7p7r4a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#22fm7p7r4a)",
    transform: "translate(-840.000000, -57.000000) translate(834.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#2C2C2C",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.502 0.206L8.502 16.213",
    transform: "translate(5.772078, 6.000000) translate(12.020815, 12.207107) rotate(45.000000) translate(-12.020815, -12.207107) translate(3.520815, 3.707107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.502 0.206L8.502 16.213",
    transform: "translate(5.772078, 6.000000) translate(12.020815, 12.207107) rotate(45.000000) translate(-12.020815, -12.207107) translate(3.520815, 3.707107) translate(8.502236, 8.209343) rotate(-90.000000) translate(-8.502236, -8.209343)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Searchclose);
export default __webpack_public_path__ + "static/media/icon-24-searchclose.ba6a92949e6913af3ec7e5ba22cdba95.svg";
export { ForwardRef as ReactComponent };